import React from 'react';
import SlimHero from '../ui/hero/hero-slim';
import { Compass5X } from '../ui/shared/icons';
import './css/about.css';

export default () => {
  return <>
    <SlimHero title="About NRNA Australia" icon={Compass5X} />
    <div className="row">
      <div className="flex-col flex-col-over-768 col-max-width-768">
        <div>
          <p>NRNA Australia is to unite all Non-Resident Nepali (NRNs) people and Nepalese organizations throughout the Australia under one umbrella organization to form a unified and institutional movement to achieve the mutual benefit between all NRNs and people of Nepali origin in Australia. At the same time, to be inclusive in this multicultural Australia by promoting Nepalese culture at the same time embracing other cultures and respecting the values and law of Australia. In addition to this, NRNA Australia also looks at the interest of second-generation people of Nepali origin and beyond.</p>
          <h2>NRNA Australia Vision</h2>
          <p>The main aim of NRNA Australia is to be inclusive in this multicultural Australia by promoting Nepalese culture, language, food and interest or people of Nepali origin and at the same time embracing other cultures and respecting the values and law of Australia. NRNA Australia aim is to keep the Nepalese language, culture and food alive in second generation people of Nepali origin and beyond.</p>
          <p>Our other main aim is to lobby the Nepal Government to legislate in favor of all NRNs such as full dual citizenship providing voting rights and creating favorable investment environment in Nepal, which will benefit both NRNs and the people of Nepal. </p>
          <h2>Objectives</h2>
          <ul>

            <li>
              <p>To promote and protect the rights and interest of people of Nepali origin residing in Australia</p>
            </li>
            <li>
              <p>To attract and facilitate NRNs investment including Foreign Direct Investment (FDI) for economic and social development of Nepal</p>
            </li>
            <li>
              <p>To promote tourism of Nepal and preserve Nepali culture, language and heritage in multiculturism Australia</p>
            </li>
            <li>
              <p>To serve as the Australian Chapter of the NRNA and to support the objectives of NRNA within Australia, subject to the laws of Australia</p>
            </li>
            <li>
              <p>To be an integral part of the development and management of philanthropic and charitable projects in Australia and Nepal, for the benefit of people of Nepali origin</p>
            </li>
            <li>
              <p>To promote and further the interests, development, and welfare of the Nepali diaspora in Australia and help them to realize their full potential both individually and as a community</p>
            </li>
            <li>
              <p>To work closely with the Australian communities, charity organizations and not-for-profit organizations and the Australian State, Territory and Federal governments.</p>
            </li>
            <li>
              <p>To contribute to the overall development of Nepal by utilizing talents, knowledge, skills, capital and other resources of people of Nepali origin and Nepalese community living in Australia</p>
            </li>
            <li>
              <p>To advance the Nepalese language in different level of schools in all State and Territory in the multiculturism Australia;</p>
            </li>
            <li>
              <p>To advance Nepali culture in multiculturism Australia</p>
            </li>
            <li>
              <p>To promote reconciliation, mutual respect and tolerance between groups of individuals that are in Australia</p>
            </li>
            <li>
              <p>To bring together different Nepalese associations in different States or Territories together for common goal of utilizing resources, capital and skills for the interest of people of Nepali origin</p>
            </li>
            <li>
              <p>To advance social or public welfare by:</p>
              <p>(a) providing care to people with a physical or mental disability who require continuous care</p>
              <p>(b)arranging opportunities for people with a physical or mental disability, woman or man affected by domestic violence or financially disadvantaged people to live a respectable life either at school, work or society in Australia or overseas.</p>
            </li>

          </ul>
        </div>
      </div>
    </div>

  </>
}
